var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ToolbarItemContainer', {
    attrs: {
      "iconFile": _vm.isH5 ? _vm.fileIconH5 : _vm.fileIcon,
      "title": _vm.props.title || _vm.TUITranslateService.t('文件'),
      "iconWidth": "20px",
      "iconHeight": "20px",
      "needDialog": false
    },
    on: {
      "onIconClick": _vm.onIconClick
    }
  }, [_c('div', {
    class: ['file-upload', !_vm.isPC && 'file-upload-h5']
  }, [_c('input', {
    ref: "inputRef",
    attrs: {
      "title": _vm.props.title || _vm.TUITranslateService.t('文件'),
      "type": "file",
      "data-type": "file",
      "accept": "*"
    },
    on: {
      "change": _vm.sendFileMessage
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }